var _path, _ellipse, _circle, _rect, _rect2, _path2, _rect3, _path3, _rect4, _path4, _rect5, _circle2, _circle3, _circle4, _circle5, _rect6, _polygon, _path5, _path6, _path7, _path8, _path9, _path10, _circle6, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCarBeach(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 300",
    "data-imageid": "beach-f",
    imageName: "Road trip",
    className: "illustrations_image",
    style: {
      width: 200
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "_") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M297.62,52.12c35.11,9.58,68.35,36.44,69,71.5s-11.43,70.89-75.74,85.32c-60.41,13.55-203.53,19.55-241.19-23.69C14.18,144.48,26.33,77.67,89.42,55.76,133.64,40.41,229.06,33.4,297.62,52.12Z",
    fill: "#e6e6e6",
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 201.62,
    cy: 240.79,
    rx: 168.37,
    ry: 18.35,
    fill: "#e6e6e6",
    opacity: 0.45
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 207.56,
    cy: 142.3,
    r: 11.2,
    fill: "#e6e6e6"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 161.07,
    y: 125.49,
    width: 41.32,
    height: 28.11,
    fill: "#ccc"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 145.31,
    y: 131.1,
    width: 29.38,
    height: 22.5,
    fill: "#e6e6e6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.16,182.4c0-.18,0-.39,0-.6-.65-6.21-4.38-18.6-6.27-24.68l-1.12-3.52H130.86s-.76,1.29-1.8,3.52c-2.26,4.88-5.85,14.16-5.85,24.11v47.33H289V188.87Z",
    fill: "#00288f",
    className: "target-color"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.52,
    y: 180.66,
    width: 14.7,
    height: 39.39,
    rx: 7.35,
    fill: "#24285b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M136.34,157.12V181.8H123.21v-.57c0-9.95,3.59-19.23,5.85-24.11Z",
    fill: "#fff",
    opacity: 0.44
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 141.24,
    y: 157.12,
    width: 42.52,
    height: 24.68,
    fill: "#fff",
    opacity: 0.44
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M232.12,181.8H187.68V157.12h38.17C227.74,163.2,231.47,175.59,232.12,181.8Z",
    fill: "#fff",
    opacity: 0.44
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 198.32,
    y: 192.2,
    width: 12.15,
    height: 5.29,
    opacity: 0.08
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 230.99,
    r: 20.08,
    fill: "#24285b"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 162.5,
    cy: 230.99,
    r: 10.66,
    fill: "#e6e6e6"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.49,
    cy: 230.99,
    r: 20.08,
    fill: "#24285b"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 248.49,
    cy: 230.99,
    r: 10.66,
    fill: "#e6e6e6"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 288.99,
    y: 208.49,
    width: 5.73,
    height: 20.06,
    fill: "#24285b"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "138.5 144.3 138.5 147.94 141.6 147.94 141.6 153.6 145.54 153.6 145.54 147.94 207.62 147.94 207.62 153.6 211.56 153.6 211.56 147.94 214.66 147.94 214.66 144.3 138.5 144.3",
    fill: "#24285b"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M94,116.59c8.78-12.33,4.3-25.62,4.3-25.62-15.66,7.83-18.39,22.22-18.55,30.59C77.33,98,56.56,94.05,56.56,94.05a32.17,32.17,0,0,0,11.92,27.21C52.72,116.39,38.75,126,38.75,126,54.42,138.62,68,134.68,75,131a106.45,106.45,0,0,0-21.36,43.08c-4.53,18.75-1.86,65-1.86,65H67.21S58,169.71,81.42,130.61c12.5,21.65,33.78,15.8,33.78,15.8a31.84,31.84,0,0,0-15.48-16.56,30.57,30.57,0,0,0,19.7-13.11A31.78,31.78,0,0,0,94,116.59Z",
    fill: "#e6e6e6"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M328.24,131c7,3.71,20.57,7.65,36.24-5,0,0-14-9.56-29.72-4.69a32.16,32.16,0,0,0,11.91-27.21s-20.76,4-23.2,27.51c-.15-8.37-2.89-22.76-18.55-30.59,0,0-4.47,13.29,4.31,25.62a31.78,31.78,0,0,0-25.41.15,30.57,30.57,0,0,0,19.69,13.11A31.87,31.87,0,0,0,288,146.41s21.29,5.85,33.78-15.8C345.27,169.71,336,239,336,239h15.43s2.67-46.22-1.87-65A106.47,106.47,0,0,0,328.24,131Z",
    fill: "#e6e6e6"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M101.35,243s4.63-6.66-2.27-8.49,1.66-10.81-4.77-12S89,230.85,89,230.85s-4.43-3.82-7.5-.61S82.68,237,82.68,237s-6.18,2.14-2.33,6Z",
    fill: "#e6e6e6"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M92.07,243.91s2.94-5,7.27-4.41,3.87,4.41,3.87,4.41Z",
    fill: "#c9c9c9"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M320.93,238.83s3.53-5.07-1.73-6.47,1.26-8.23-3.63-9.13-4.08,6.33-4.08,6.33-3.39-2.91-5.72-.46.93,5.13.93,5.13-4.71,1.63-1.77,4.6Z",
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M322.09,247.35s2.24-3.84,5.54-3.36a3.07,3.07,0,0,1,2.95,3.36Z",
    fill: "#c9c9c9"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 265.74,
    cy: 65.81,
    r: 21.04,
    fill: "#ffd200"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M175,73.32a8.82,8.82,0,0,0-8.82-8.82,9.6,9.6,0,0,0-1.42.12,11.88,11.88,0,0,0-10.47-6.26l-.43,0a14.3,14.3,0,0,0,.43-3.42,14.11,14.11,0,1,0-28.21,0,14.3,14.3,0,0,0,.43,3.42c-.14,0-.28,0-.43,0a11.89,11.89,0,1,0,0,23.77h41.25v-.08A8.81,8.81,0,0,0,175,73.32Z",
    fill: "#e6e6e6",
    opacity: 0.49
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M253.75,110a6.28,6.28,0,0,0-6.28-6.28,6.64,6.64,0,0,0-1,.09A8.46,8.46,0,0,0,239,99.31h-.31a10.24,10.24,0,0,0,.31-2.43,10,10,0,0,0-20.08,0,10.24,10.24,0,0,0,.31,2.43h-.31a8.46,8.46,0,0,0,0,16.91h29.35v-.06A6.27,6.27,0,0,0,253.75,110Z",
    fill: "#e6e6e6",
    opacity: 0.49
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarBeach);
export default __webpack_public_path__ + "static/media/car-beach.cad4a60c17106ae24cceb4e8b76b920e.svg";
export { ForwardRef as ReactComponent };